import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SupervisorLayout from '../../components/SupervisorLayout';
import SupervisorGroupCodeField from '../../components/SupervisorGroupCodeField';
import SupervisorBankCodeField from '../../components/SupervisorBankCodeField';
import LotteryCodeField from '../../components/LotteryCodeField';
import SupervisorParameterDetailsView from './SupervisorParameterDetailsView';
import './SupervisorSeeParametersPage.css';

// Rendu dynamique (2026-09-17) : contrairement a la version company,
// ProductConfig n'a pas de "portee company" pour un superviseur (voir
// SupervisorProductConfigViewSet) — un Groupe OU une Banque est requis pour
// voir des parametres reels (meme regle que SupervisorProductConfigPage.jsx),
// mutuellement exclusif, meme resolution au blur que le reste (2026-09-17).
const SupervisorSeeParametersPage = () => {
  const [showResults, setShowResults] = useState(false);
  const [groupId, setGroupId] = useState('');
  const [groupName, setGroupName] = useState('');
  const [bankId, setBankId] = useState('');
  const [bankName, setBankName] = useState('');
  const [lottery, setLottery] = useState('1');
  const [lotteryName, setLotteryName] = useState('NY MIDI');
  const [error, setError] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (!groupId && !bankId) {
      setError('Choisis un groupe ou une banque.');
      return;
    }
    setError('');
    setShowResults(true);
  };

  if (showResults) {
    return (
      <SupervisorParameterDetailsView
        lottery={lottery}
        lotteryName={lotteryName}
        groupId={groupId}
        groupName={groupName}
        bankId={bankId}
        bankName={bankName}
        onBack={() => setShowResults(false)}
      />
    );
  }

  return (
    <SupervisorLayout>
      <p className="svsp-breadcrumb">
        Ruta : <Link to="/supervisor/dashboard" className="svsp-link">Menu</Link>
        {' >> '}
        <Link to="/supervisor/central" className="svsp-link">Central</Link>
        {' >> '}
        <span className="svsp-current">Voir Parametres</span>
      </p>

      <div className="svsp-card">
        <div className="svsp-card-header">
          <span className="svsp-card-title">Consultar Parametros</span>
        </div>
        <div className="svsp-card-body">
          <form onSubmit={handleSearch} className="svsp-form">
            <div className="svsp-row">
              <label className="svsp-label">Groupe</label>
              <SupervisorGroupCodeField
                value={groupId}
                name={groupName}
                onChange={(id) => { setGroupId(id); setGroupName(''); }}
                onResolve={(id, nm) => {
                  setGroupId(id); setGroupName(nm);
                  setBankId(''); setBankName('');
                }}
                inputClass="svsp-input svsp-input-sm"
                iconClass="svsp-icon-btn"
                nameClass="svsp-lottery-name"
              />

              <label className="svsp-label svsp-label-gap">Banque</label>
              <SupervisorBankCodeField
                value={bankId}
                name={bankName}
                onChange={(id) => { setBankId(id); setBankName(''); }}
                onResolve={(id, nm) => {
                  setBankId(id); setBankName(nm);
                  setGroupId(''); setGroupName('');
                }}
                inputClass="svsp-input svsp-input-sm"
                iconClass="svsp-icon-btn"
                nameClass="svsp-lottery-name"
              />
            </div>

            <div className="svsp-row">
              <label className="svsp-label">Lottery</label>
              <LotteryCodeField
                value={lottery}
                name={lotteryName}
                onChange={(code) => { setLottery(code); setLotteryName(''); }}
                onResolve={(code, nm) => { setLottery(code); setLotteryName(nm); }}
                inputClass="svsp-input svsp-input-sm"
                iconClass="svsp-icon-btn"
                nameClass="svsp-lottery-name"
              />
            </div>

            {error && <p className="svsp-error">{error}</p>}

            <button type="submit" className="svsp-search-btn">Search</button>
          </form>
        </div>
      </div>
    </SupervisorLayout>
  );
};

export default SupervisorSeeParametersPage;
